import React from "react";
import { Field, ConfigInput } from "./Field";

export default function PipedriveFields({ config, setConfig }) {
  return (
    <>
      <Field label="API token" required colSpan={2}>
        <ConfigInput name="api_token" config={config} setConfig={setConfig}
          testId="dest-pipedrive-token" required type="password"
          placeholder="From Pipedrive → Personal Preferences → API" />
      </Field>
      <Field label="Owner ID (optional)"
        hint="Assigns the created Person to a specific Pipedrive user. Omit to use API-key default.">
        <ConfigInput name="owner_id" config={config} setConfig={setConfig}
          type="number" placeholder="e.g. 12345" />
      </Field>
      <Field label="Custom endpoint (optional)">
        <ConfigInput name="endpoint" config={config} setConfig={setConfig}
          placeholder="Defaults to https://api.pipedrive.com/api/v2/persons" className="text-xs" />
      </Field>
    </>
  );
}
